import { render, staticRenderFns } from "./MiCRUD.vue?vue&type=template&id=1363ca81&"
import script from "./MiCRUD.vue?vue&type=script&lang=js&"
export * from "./MiCRUD.vue?vue&type=script&lang=js&"
import style0 from "./MiCRUD.vue?vue&type=style&index=0&id=1363ca81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports